import { type HTMLAttributes } from "react";
import { useInterruptCard } from "../InterruptCardContext";
import { humanizeAction } from "../utils";

/**
 * Renders `interrupt.title` if present, falling back to humanizing the
 * (internal-dispatch) `action` string when the producer didn't set a title.
 *
 * Style with className override; defaults to a sensible heading.
 */
export function Header(props: HTMLAttributes<HTMLHeadingElement>) {
  const { interrupt } = useInterruptCard();
  const text = interrupt.title || humanizeAction(interrupt.action_request.action);
  return (
    <h3
      {...props}
      className={["text-base font-semibold text-zinc-900", props.className]
        .filter(Boolean)
        .join(" ")}
    >
      {text}
    </h3>
  );
}
